/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MenuTreeBasic } from '../model';
// @ts-ignore
import { MenuTreeDetail } from '../model';
// @ts-ignore
import { RoleBasic } from '../model';
/**
 * PreferencesApi - axios parameter creator
 * @export
 */
export const PreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get menus for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuTreeBasic: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/preferences/menu/menuTreeBasic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get menus for editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuTreeDetail: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/preferences/menu/admin/menuTreeDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get roles for editing menus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForMenus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/preferences/menu/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or replace all menus for org
         * @param {Array<MenuTreeDetail>} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMenuTreeDetail: async (data?: Array<MenuTreeDetail>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/preferences/menu/admin/menuTreeDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreferencesApi - functional programming interface
 * @export
 */
export const PreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get menus for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuTreeBasic(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuTreeBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuTreeBasic(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get menus for editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuTreeDetail(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuTreeDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuTreeDetail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get roles for editing menus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesForMenus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesForMenus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or replace all menus for org
         * @param {Array<MenuTreeDetail>} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMenuTreeDetail(data?: Array<MenuTreeDetail>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuTreeDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMenuTreeDetail(data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreferencesApi - factory interface
 * @export
 */
export const PreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get menus for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuTreeBasic(options?: any): AxiosPromise<Array<MenuTreeBasic>> {
            return localVarFp.getMenuTreeBasic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get menus for editing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuTreeDetail(options?: any): AxiosPromise<Array<MenuTreeDetail>> {
            return localVarFp.getMenuTreeDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get roles for editing menus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForMenus(options?: any): AxiosPromise<Array<RoleBasic>> {
            return localVarFp.getRolesForMenus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or replace all menus for org
         * @param {Array<MenuTreeDetail>} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMenuTreeDetail(data?: Array<MenuTreeDetail>, options?: any): AxiosPromise<Array<MenuTreeDetail>> {
            return localVarFp.saveMenuTreeDetail(data, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreferencesApi - object-oriented interface
 * @export
 * @class PreferencesApi
 * @extends {BaseAPI}
 */
export class PreferencesApi extends BaseAPI {
    /**
     * 
     * @summary Get menus for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getMenuTreeBasic(options?: any) {
        return PreferencesApiFp(this.configuration).getMenuTreeBasic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get menus for editing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getMenuTreeDetail(options?: any) {
        return PreferencesApiFp(this.configuration).getMenuTreeDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get roles for editing menus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getRolesForMenus(options?: any) {
        return PreferencesApiFp(this.configuration).getRolesForMenus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or replace all menus for org
     * @param {Array<MenuTreeDetail>} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public saveMenuTreeDetail(data?: Array<MenuTreeDetail>, options?: any) {
        return PreferencesApiFp(this.configuration).saveMenuTreeDetail(data, options).then((request) => request(this.axios, this.basePath));
    }
}
